import React from 'react';

export default function useInterval(callback, interval) {
    const savedCallback = React.useRef(callback);

    // Remember the latest callback if it changes.
    React.useLayoutEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    React.useEffect(() => {
        // Don't schedule if no interval is specified.
        // Note: 0 is a valid value for interval.
        if (!interval && interval !== 0) {
            return;
        }

        const id = setInterval(() => savedCallback.current(), interval);

        return () => clearInterval(id);
    }, [interval]);
}
